// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"6b3c3d05","453":"62f71aa6","667":"3bfb3fd1","821":"932524d0"}[chunkId] + ".chunk.js";
};